import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';

type Props = {
  date: string;
  salesItems: {
    id: number;
    name: string;
  }[];
  variant?: 'upcoming' | 'completed';
  deliveryWindowStartsAt?: string;
  deliveryWindowEndsAt?: string;
  cancelledAt?: string | null;
  cancelledLabel?: string;
};

export const BookingInFleetTable = ({
  date,
  salesItems,
  variant = 'completed',
  deliveryWindowStartsAt,
  deliveryWindowEndsAt,
  cancelledAt,
  cancelledLabel = 'Cancelled'
}: Props) => {
  const isUpcoming = variant === 'upcoming';
  const isCancelled = !!cancelledAt;
  const displayDate = noddiFormatDate(date, NoddiDateFormats.DATE);

  return (
    <div className='flex flex-col gap-1 py-1'>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex flex-col'>
          <div className='flex items-center gap-2 whitespace-nowrap'>
            <NoddiIcon name={isCancelled ? 'CalendarX' : isUpcoming ? 'CalendarClock' : 'Calendar'} />
            <span className='text-sm font-semibold'>{displayDate}</span>
            {isCancelled && <NoddiBadge variant='destructive'>{cancelledLabel}</NoddiBadge>}
            <div className='text-xs text-muted-foreground'>
              {isUpcoming && !isCancelled && deliveryWindowStartsAt && deliveryWindowEndsAt && (
                <span>
                  {`${noddiFormatDate(
                    deliveryWindowStartsAt,
                    NoddiDateFormats.TIME
                  )} - ${noddiFormatDate(deliveryWindowEndsAt, NoddiDateFormats.TIME)}`}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {salesItems.length > 0 && (
        <div className='minimal-scrollbar-hover -mr-3 max-h-16 overflow-y-auto pr-3'>
          <div className='flex flex-col gap-0.5'>
            {salesItems.map((item) => (
              <div
                key={`salesItem-${item.id}`}
                className='w-40 truncate border-b-muted-foreground text-xs text-wrap [&:not(:last-child)]:border-b [&:not(:last-child)]:pb-1'
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
